import React, { useEffect, useState } from "react";
import ReactGA from "react-ga";
import { checkUsername, resetErrors } from "../store/actions/homeActions";

import ReactPixel from 'react-facebook-pixel';

import { languageService } from "./lang/Lang.js";

import { connect } from "react-redux";
import { compose } from "redux";

import { Link } from "react-router-dom";

import { Redirect } from 'react-router-dom';


function Register(props) {

  const { checkUsernameFn, errore, loggedin, resetErrorsFn } = props;

  const [username, setusername] = useState(null);
  const [firstname, setfirstname] = useState(null);
  const [lastname, setlastname] = useState(null);
  const [password, setpassword] = useState(null);
  const [confirmPassword, setconfirmPassword] = useState(null);
  const [passwordError, setpasswordError] = useState(null);

  //const new_lang = languageService.getLanguage();


  const handleSubmit = (e) => {

    e.preventDefault();

    // Validate password match
    if (password !== confirmPassword) {
      setpasswordError(languageService.translate('register.passwordMismatch') || 'Passwords do not match');
      return;
    }

    // Validate password length
    if (!password || password.length < 6) {
      setpasswordError(languageService.translate('register.passwordTooShort') || 'Password must be at least 6 characters');
      return;
    }

    setpasswordError(null);

    let laang = languageService.getLanguage();

    checkUsernameFn(username, firstname, lastname, password, laang);

    ReactGA.event({
      category: "User",
      action: "Registered",
    });

    ReactPixel.track("Lead", null);



  };

  useEffect(() => {

    setTimeout(() => {
      resetErrorsFn();
    }, 8000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errore]);

  return loggedin ? <Redirect to="/chat" /> : (
    <div className="container" style={{ marginTop: "60px" }}>
      <div className="columns" style={{ margin: 13, background: "white", borderRadius: "3px" }}>
        <div
          className="column"
          style={{
            color: "black",
            padding: "10px !important",
          }}
        >
          <form onSubmit={handleSubmit} style={{}}>
            <div style={{ height: "10px" }}></div>

            <p><b>{languageService.translate('register.t1')}:</b></p>
            <div style={{ height: "10px" }}></div>
            <div className="field">
              <p className="control has-icons-left">
                <input
                  required
                  className="input"
                  type="text"
                  placeholder={languageService.translate('register.t2')}
                  id="username"
                  name="username"
                  onChange={(v) => {
                    setusername(v.target.value);
                  }}
                  style={{ color: "#4b6385", fontSize: "1.2em" }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-envelope"></i>
                </span>
              </p>
            </div>


            <div className="field">
              <p className="control has-icons-left">
                <input
                  required
                  className="input"
                  type="text"
                  placeholder={languageService.translate('register.t3')}
                  id="firstname"
                  name="firstname"
                  onChange={(v) => {
                    setfirstname(v.target.value);
                  }}
                  style={{ color: "#4b6385", fontSize: "1.2em" }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-user"></i>
                </span>
              </p>
            </div>


            <div className="field">
              <p className="control has-icons-left">
                <input
                  required
                  className="input"
                  type="text"
                  placeholder={languageService.translate('register.t4')}
                  id="lastname"
                  name="lastname"
                  onChange={(v) => {
                    setlastname(v.target.value);
                  }}
                  style={{ color: "#4b6385", fontSize: "1.2em" }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-user"></i>
                </span>
              </p>
            </div>

            <div className="field">
              <p className="control has-icons-left">
                <input
                  required
                  className="input"
                  type="password"
                  placeholder={languageService.translate('register.password') || 'Password'}
                  id="password"
                  name="password"
                  onChange={(v) => {
                    setpassword(v.target.value);
                    setpasswordError(null);
                  }}
                  style={{ color: "#4b6385", fontSize: "1.2em" }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-lock"></i>
                </span>
              </p>
            </div>

            <div className="field">
              <p className="control has-icons-left">
                <input
                  required
                  className="input"
                  type="password"
                  placeholder={languageService.translate('register.confirmPassword') || 'Confirm Password'}
                  id="confirmPassword"
                  name="confirmPassword"
                  onChange={(v) => {
                    setconfirmPassword(v.target.value);
                    setpasswordError(null);
                  }}
                  style={{ color: "#4b6385", fontSize: "1.2em" }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-lock"></i>
                </span>
              </p>
            </div>

            <div style={{ height: "5px" }}></div>


            <label className="checkbox">
              <input type="checkbox"
                required
              />
              &nbsp;<i>{languageService.translate('register.t5')} <Link to="/terms">{languageService.translate('register.t6')}</Link> {languageService.translate('register.t7')} <Link to="/privacy">{languageService.translate('register.t8')}</Link></i>.
            </label>

            <div style={{ height: "20px" }}></div>











            <div className="field">
              <button
                style={{
                  padding: "10px 15px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  border: 0,
                  color: "#fff",
                  background: "#F35875",
                  borderRadius: "3px",
                }}
              >
                {languageService.translate('register.t9')}
              </button>
            </div>

            {passwordError ? <p style={{ color: "red" }}>{passwordError}</p> : null}
            {errore ? <p style={{ color: "red" }}>{languageService.translate("reducer.t2")}</p> : null}
          </form>
          <div style={{ height: "20px" }}></div>

          <p> {languageService.translate('recovery.t5')} <Link to="/login" style={{ color: "#F35875" }}>{languageService.translate('recovery.t6')}</Link>.</p>





        </div>
      </div>
    </div>);

}

const mapStateToProps = (state) => {
  return {
    errore: state.home.errore,
    loggedin: state.home.loggedin,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkUsernameFn: (username, firstname, lastname, password, lang) => dispatch(checkUsername(username, firstname, lastname, password, lang)),
    resetErrorsFn: () => dispatch(resetErrors()),


  };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Register);
